<template>
  <div class="container-fluid">
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="box info-box">
            <div class="box-header with-border">
              Search By
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-3" v-if="canAccess('branch-view-any')">
                  <label for="Branch">Branch</label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="changeFilter()"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="date">Date</label>
                  <input type="date" v-model="emiDate" name="emiDate" class="form-control" @change="changeFilter()" placeholder="EMI Date">
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>

          <div class="info-box"  v-if="canAccess('member-collection-approve')">
            <div class="box-header with-border">
              <h3 class="box-title">Salary List For Approved</h3>
              <div class="box-tools">
              </div>

            </div>
            <div class="box-body">
                <div class="row">
                    <div class="col-sm-6 col-xs-6">
                    <label>
                        <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        </select>
                    </label>
                    </div>
                    <div class="col-sm-6 col-xs-6">
                    <div class="input-group pull-right input-group-sm" style="width: 150px;">
                        <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                        <div class="input-group-btn">
                        <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                        </div>
                    </div>
                    </div>
                </div>
                <table class="table table-sm table-bordered table-hover">
                    <thead style="background-color: #d6dddd;">
                    <tr>
                        <th class="hidden-xs">Sr. No.</th>
                        <th>Name</th>
                        <th class="hidden-xs">Mobile</th>
                        <th class="hidden-xs">Branch</th>
                        <th class="hidden-xs">Salary</th>
                        <th class="hidden-xs">Payment Mode</th>
                        <th class="hidden-xs">Transaction Date</th>
                        <th class="hidden-xs">Cheque Date</th>
                        <th class="hidden-xs">Remark</th>
                        <th>Action</th>
                        <!-- <th>Action</th> -->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in rows.data" :key="index">
                        <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                        <td><i v-if="row.employee">{{ row.employee.name }} ({{ row.employee.code}})</i></td>
                        <td class="hidden-xs"><i v-if="row.employee">{{ row.employee.mobile }}</i></td>
                        <td class="hidden-xs"><i v-if="row.branch">{{ row.branch.name }}</i></td>
                        <td class="hidden-xs">{{row.salary}}</td>
                        <td class="hidden-xs">{{row.payMode}}</td>
                        <td class="hidden-xs">{{row.transactionDate | myDate}}</td>
                        <td class="hidden-xs">{{row.chequeDate | myDate}}</td>
                        <td class="hidden-xs">{{row.remark}}</td>
                        <td>
                        <div class="btn-group">
                            <button
                                v-if="canAccess('salary-disbursement-view')"
                                @click="viewModal(row)"
                                class="btn btn-info btn-xs"
                            >
                                <i class="fa fa-eye"></i>
                            </button>
                            <button
                              v-if="canAccess('salary-disbursement-approve')"
                              @click="confirmPayment(row)"
                              class="btn btn-success btn-xs"
                            >
                              <i class="fa fa-check"></i>
                            </button>
                            <button
                              v-if="canAccess('salary-disbursement-delete')"
                              @click="confirmPaymentDelete(row)"
                              class="btn btn-danger btn-xs"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                        </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                    
            </div>
            <!-- /.box-body -->
            <div class="box-footer clearfix" v-if="pagination.current_page > 0">
              <div class="row">
                <div class="col-sm-4">
                  Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
                </div>
                <div class="col-sm-8">
                  <ul class="pagination pagination-sm no-margin pull-right">
                    <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                    <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                    <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                    <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                    <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                    <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                    <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                    <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                    <li><a href="#">...</a></li>
                    
                    <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                    <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                    <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                    <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                    <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- /.box-footer-->
          </div>
          <!-- /.box -->

        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
    <viewsalaryrecords :empInfo="empInfo"></viewsalaryrecords>
  </div>
</template>

<script>
// var _ = require('lodash')
import viewsalaryrecords from '../components/ViewSalaryRecords.vue'
import GetBranch from '../../mixins/BranchRecords'
export default {
  name: 'my-component',
  components: {
    viewsalaryrecords
  },
  mixins: [GetBranch],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      emiDate: null,
      empInfo: {},
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      pancardNumber: '',
      branches: [],
      branch: {},
      members: {},
      staffs: {},
      banks: {},
      pl: {},
      seeRecord: {},
      loanplans: [],
      memberloanplans: [],
      memberloanplan: {},
      groupMembers: {},
      loadDisbursements: {},
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        amt: '',
        plan: {},
        planType: '',
        member_id: '',
        status: '',
        disbursement_id: '',
        paymentDate: '',
        emiStartDate: '',
        paymentMode: '',
        bank_id: ''
      }),
      columns: [
        {
          label: 'EMI DATE',
          field: 'emiDate'
        },
        {
          label: 'PRINCIPAL',
          field: 'principal'
        },
        {
          label: 'INTEREST',
          field: 'intrest'
        },
        {
          label: 'TOTAL',
          field: 'total'
        },
        {
          label: 'ADJUSTMENT',
          field: 'adjustment'
        },
        {
          label: 'BALANCE',
          field: 'balance'
        },
        {
          label: 'RECEIVED',
          field: 'received'
        },
        {
          label: 'ARRIER',
          field: 'arrear'
        },
        {
          label: 'ADVANCE',
          field: 'advance'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rows: [],
      columnsMemberCollections: [
        {
          label: 'LOAN ID',
          field: 'member_loan_plan.applicationNo'
        },
        {
          label: 'MEM CODE',
          field: 'member.code'
        },
        {
          label: 'MEM NAME',
          field: 'member.name'
        },
        {
          label: '(C/O) ALIAS',
          field: 'member.alias'
        },
        {
          label: 'MEM MOB',
          field: 'member.mobile'
        },
        {
          label: 'PAYMENT DATE',
          field: 'paymentdate'
        },
        {
          label: 'AMOUNT',
          field: 'amt'
        },
        {
          label: 'RECEIVED BY',
          field: 'received_by.name'
        },
        {
          label: 'EMP CODE',
          field: 'received_by.code'
        },
        {
          label: 'PAYMENT MODE',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rowsMemberCollections: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    viewModal (row) {
      this.editMode = false
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.empInfo = row
    },
    confirmPayment (row) {
      Swal.fire({ title: 'Are you sure?', text: 'You Confirm this Payment !', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Save it!' })
      .then((result) => {
        if (result.isConfirmed) {
          this.$axios.post('salarydisbursement/approve/' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              Swal.fire('Paid!', 'Payment Paid Successfully.', 'success')
            })
        }
      })
    },
    confirmPaymentDelete (row) {
      Swal.fire({ title: 'Are you sure?', text: 'You Delete this Payment !', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Save it!' })
      .then((result) => {
        if (result.isConfirmed) {
          this.$axios.delete('salarydisbursement/' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
            //   Fire.$emit('AfterCreate')
              this.changeFilter()
              Toast.fire({
                icon: 'success',
                title: 'Payment Record Deleted Successfully'
              })
            })
        }
      })
    },
    changeFilter (page = null, pg = null, status = null) {
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path + '?status=pending'
      } else {
        pageUrl += 'salarydisbursement?status=pending'
      }

      if (pg == null) {
        pageUrl += `&per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    getMemberLoanPlan () {
      this.$axios
        .get('memberloanplan?all=all&branch_id=' + this.form.branch_id + '&searchTerm=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberloanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    this.getBranch()
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// approveSalary.vue?72e1d7d3